module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t("userStatisticsView.title")))]), _vm._v(" "), _c('table', [_c('thead', [_c('th', [_vm._v(_vm._s(_vm.$t("userStatisticsView.event")))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("userStatisticsView.paidSum")))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("userStatisticsView.estimated")))])]), _vm._v(" "), _c('tbody', _vm._l((_vm.store.events), function(e) {
    return _c('tr', {
      key: e.eventId
    }, [_c('td', [_vm._v(_vm._s(e.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getSponsorsPaymentSum(e.sponsors)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getSponsorsEstimatedPayment(e.sponsors)))])])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1cc02776","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/ts/views/UserStatisticsView.vue
// module id = 112
// module chunks = 0